/**
 * Shared signature font + color config.
 * Used by SignatureGeneratorTool (all 12) and TypeSignature (first 4).
 */

export const SIGNATURE_FONTS = [
  { name: "Dancing Script", family: "'Dancing Script', cursive", label: "Cursive" },
  { name: "Great Vibes", family: "'Great Vibes', cursive", label: "Formal" },
  { name: "Allura", family: "'Allura', cursive", label: "Allura" },
  { name: "Pacifico", family: "'Pacifico', cursive", label: "Pacifico" },
  { name: "Caveat", family: "'Caveat', cursive", label: "Caveat" },
  { name: "Satisfy", family: "'Satisfy', cursive", label: "Satisfy" },
  { name: "Sacramento", family: "'Sacramento', cursive", label: "Script" },
  { name: "Yellowtail", family: "'Yellowtail', cursive", label: "Yellowtail" },
  { name: "Alex Brush", family: "'Alex Brush', cursive", label: "Elegant" },
  { name: "Kaushan Script", family: "'Kaushan Script', cursive", label: "Kaushan" },
  { name: "Pinyon Script", family: "'Pinyon Script', cursive", label: "Pinyon" },
  { name: "Indie Flower", family: "'Indie Flower', cursive", label: "Handwritten" },
] as const;

export const FONT_LOAD_URL =
  "https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600;700&family=Great+Vibes&family=Allura&family=Pacifico&family=Caveat:wght@700&family=Satisfy&family=Sacramento&family=Yellowtail&family=Alex+Brush&family=Kaushan+Script&family=Pinyon+Script&family=Indie+Flower&display=swap";

/** First 2 fonts — the default font + first visible in grids. Load first for fast LCP. */
export const FONT_LOAD_URL_PRIMARY =
  "https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600;700&family=Great+Vibes&display=swap";

/** Remaining 10 fonts — defer until after first paint. */
export const FONT_LOAD_URL_DEFERRED =
  "https://fonts.googleapis.com/css2?family=Allura&family=Pacifico&family=Caveat:wght@700&family=Satisfy&family=Sacramento&family=Yellowtail&family=Alex+Brush&family=Kaushan+Script&family=Pinyon+Script&family=Indie+Flower&display=swap";

export const SIGNATURE_COLORS = [
  { name: "Black", value: "#000000" },
  { name: "Dark Blue", value: "#1a365d" },
  { name: "Navy", value: "#0c1e3a" },
  { name: "Blue", value: "#2563eb" },
] as const;
